export default "__VITE_ASSET__4489a678__"